export const hasLimitValue = value => value !== null && value !== undefined && value !== '';

export const normalizePercentageLimit = value => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) return numericValue;

  return Number((numericValue * 100).toFixed(10));
};

export const isOutsidePercentageLimit = (value, min, max) => {
  if (!hasLimitValue(value)) return false;

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) return false;

  if (hasLimitValue(max) && numericValue > normalizePercentageLimit(max)) return true;
  if (hasLimitValue(min) && numericValue < normalizePercentageLimit(min)) return true;

  return false;
};

// A quebra exibida avalia o valor da visão atual (min/max do campo). O veredito da API
// (brokenLimit/brokenLimitTypes) só aparece como aviso com o filtro de limites aplicado.
export const isMarginLimitBroken = (content, margin) => isOutsidePercentageLimit(margin, content?.minMargin, content?.maxMargin);

export const isCompetitivenessLimitBroken = (content, cpi) => isOutsidePercentageLimit(cpi, content?.minCpi, content?.maxCpi);
